import { useState } from 'react';

import {
  Button,
  ButtonDropdown,
  Modal,
  useToaster,
} from '@skillarea/lib-frontend';
import { createFileRoute } from '@tanstack/react-router';

const LAYER_OPTIONS = [
  {
    value: 'alpha',
    label: 'Alpha',
  },
  {
    value: 'beta',
    label: 'Beta',
  },
] as const;

const DROPDOWN_TRIGGER_PROPS = {
  id: 'layers-dropdown',
  'data-testid': 'layers-dropdown',
} as const;

export const Route = createFileRoute('/__e2e__/layers')({
  component: LayersHarnessPage,
});

export function LayersHarnessPage() {
  const { toast } = useToaster();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedLayerOption, setSelectedLayerOption] = useState<string>(
    LAYER_OPTIONS[0].value,
  );

  return (
    <div style={{ padding: 24 }}>
      <Button
        data-testid="layers-open-modal"
        onClick={() => setIsModalOpen(true)}
        size="s"
        variant="outline"
      >
        Open layering modal
      </Button>

      <Modal
        isOpen={isModalOpen}
        onBeforeClose={() => setIsModalOpen(false)}
        title="Layer harness modal"
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            padding: 16,
          }}
        >
          <Button
            data-testid="layers-trigger-toast"
            onClick={() => toast.info('Layer test')}
            size="s"
            variant="outline"
          >
            Trigger toast
          </Button>

          <ButtonDropdown
            {...DROPDOWN_TRIGGER_PROPS}
            items={LAYER_OPTIONS}
            onChange={setSelectedLayerOption}
            size="s"
            value={selectedLayerOption}
            variant="outline"
          />
        </div>
      </Modal>
    </div>
  );
}
